import { render, staticRenderFns } from "./FiscalUsers.vue?vue&type=template&id=064d313a&scoped=true"
import script from "./FiscalUsers.vue?vue&type=script&lang=js"
export * from "./FiscalUsers.vue?vue&type=script&lang=js"
import style0 from "./FiscalUsers.vue?vue&type=style&index=0&id=064d313a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d313a",
  null
  
)

export default component.exports